var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send Email Without Attachment - iconSvg.co"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M109.146 101.778C105.356 101.812 101.688 100.436 98.8548 97.9175L56.6638 59.6781C55.3606 58.5163 54.9115 56.6692 55.5377 55.0378C56.1639 53.4077 57.7336 52.3352 59.4805 52.3448H158.793C160.533 52.3475 162.093 53.4173 162.721 55.0419C163.349 56.6652 162.913 58.5068 161.627 59.6783L119.418 97.9178C116.59 100.432 112.929 101.808 109.146 101.778L109.146 101.778ZM59.4809 56.3453L101.598 94.9047C103.703 96.6982 106.379 97.6828 109.144 97.6828C111.909 97.6828 114.584 96.6982 116.689 94.9047L158.898 56.6476L125.104 56.3455L59.4809 56.3453Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.1093 122.485L89.0001 87.001L91.8813 89.8821L56.9904 125.366L54.1093 122.485Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M125.708 89.761L128.589 86.8799L164.02 122.31L161.139 125.192L125.708 89.761Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M160.369 127.656H57.9235C56.303 127.656 54.7484 127.012 53.6031 125.865C52.4564 124.72 51.8137 123.166 51.8137 121.545V112.902H42.7445C41.6197 112.902 40.7079 111.99 40.7079 110.865C40.7079 109.74 41.6197 108.828 42.7445 108.828H53.8503C54.9709 108.838 55.8773 109.744 55.8869 110.865V121.493V121.491C55.8471 122.054 56.0449 122.608 56.4321 123.018C56.8194 123.429 57.3591 123.66 57.9235 123.653H160.369C161.495 123.653 162.407 122.741 162.407 121.616V58.4546C162.426 57.9026 162.22 57.3656 161.836 56.9687C161.451 56.5705 160.922 56.3466 160.369 56.3466H57.9235C57.3824 56.3425 56.8606 56.5554 56.4788 56.9385C56.0957 57.3217 55.8828 57.8421 55.8869 58.3846V70.0041V70.0027C55.8869 71.1274 54.975 72.0407 53.8503 72.0407H24.1995C23.6296 72.0929 23.0625 71.9034 22.6381 71.5175C22.2152 71.1316 21.9734 70.585 21.9734 70.0124C21.9734 69.4383 22.2152 68.8918 22.6381 68.5058C23.0625 68.1199 23.6296 67.9304 24.1995 67.984H51.8137V58.4549C51.8137 56.8344 52.4564 55.2799 53.6031 54.1345C54.7484 52.9878 56.303 52.3438 57.9235 52.3438H160.369C161.991 52.3438 163.544 52.9878 164.691 54.1345C165.836 55.2799 166.48 56.8344 166.48 58.4549V121.546C166.48 123.167 165.836 124.721 164.691 125.867C163.544 127.013 161.991 127.657 160.369 127.657V127.656Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.7399 81.5703H41.3083C40.1836 81.5703 39.2717 80.6584 39.2717 79.5337C39.2717 78.409 40.1836 77.4971 41.3083 77.4971H62.7399C63.8646 77.4971 64.7778 78.409 64.7778 79.5337C64.7778 80.6584 63.8646 81.5703 62.7399 81.5703Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.7117 91.0267H15.6105C14.4857 91.0267 13.5739 90.1148 13.5739 88.9887C13.5739 87.864 14.4857 86.9521 15.6105 86.9521H44.7117C45.8365 86.9521 46.7483 87.864 46.7483 88.9887C46.7483 90.1148 45.8365 91.0267 44.7117 91.0267Z",
    fill: "#173325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M53.2653 100.786H37.1468C36.0221 100.786 35.1102 99.8742 35.1102 98.7495C35.1102 97.6248 36.0221 96.7129 37.1468 96.7129H53.2653C54.39 96.7129 55.3019 97.6248 55.3019 98.7495C55.3019 99.8742 54.39 100.786 53.2653 100.786Z",
    fill: "#173325"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59 56L101.788 95.1773C103.927 96.9996 106.644 98 109.454 98C112.263 98 114.981 96.9996 117.119 95.1773L160 56.3072L125.668 56.0002L59 56Z",
    fill: "#C3E6D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send_email.21bc14e63ca89bcd55d0d40f4f80a5a0.svg";
export { ForwardRef as ReactComponent };